const MAX_HISTORY_ITEMS = 25;

function isNonEmptyString(value) {
  return typeof value === 'string' && value.trim().length > 0;
}

function toTrimmedString(value) {
  return typeof value === 'string' ? value.trim() : '';
}

export function isIsoDateString(value) {
  return isNonEmptyString(value) && !Number.isNaN(Date.parse(value));
}

export function normalizeReportRecord(report = {}) {
  const candidate = report && typeof report === 'object' ? report : {};
  const projectGuid = toTrimmedString(candidate.projectGuid) || null;
  const reportUrl = toTrimmedString(candidate.reportUrl);
  const projectType = toTrimmedString(candidate.projectType) || null;
  const title = toTrimmedString(candidate.title) || null;
  const savedAt = isIsoDateString(candidate.savedAt)
    ? candidate.savedAt
    : new Date().toISOString();

  if (!reportUrl) {
    return null;
  }

  return {
    projectGuid,
    reportUrl,
    projectType,
    title,
    savedAt
  };
}

export function isValidLatestReport(report) {
  const normalized = normalizeReportRecord(report);
  return Boolean(normalized && normalized.reportUrl);
}

export function dedupeHistory(history = []) {
  const seenGuids = new Set();
  const seenUrls = new Set();
  const normalized = [];

  history.forEach((item) => {
    const nextItem = normalizeReportRecord(item);
    if (!nextItem) {
      return;
    }

    if (nextItem.projectGuid) {
      if (seenGuids.has(nextItem.projectGuid)) {
        return;
      }
      seenGuids.add(nextItem.projectGuid);
    } else if (seenUrls.has(nextItem.reportUrl)) {
      return;
    }

    seenUrls.add(nextItem.reportUrl);
    normalized.push(nextItem);
  });

  normalized.sort((left, right) => {
    return new Date(right.savedAt).getTime() - new Date(left.savedAt).getTime();
  });

  return normalized.slice(0, MAX_HISTORY_ITEMS);
}

export function normalizeLatestReportState(state) {
  const latest = normalizeReportRecord(state?.latest) || null;
  const history = dedupeHistory([
    ...(latest ? [latest] : []),
    ...(Array.isArray(state?.history) ? state.history : [])
  ]);

  return {
    latest,
    history
  };
}

export function formatSavedDate(savedAt) {
  if (!isIsoDateString(savedAt)) {
    return '';
  }

  try {
    return new Date(savedAt).toLocaleDateString(undefined, {
      month: 'short',
      day: 'numeric'
    });
  } catch {
    return '';
  }
}

export function getHistoryIdentifier(report) {
  if (!report) {
    return null;
  }

  return report.projectGuid || report.reportUrl || null;
}

export { MAX_HISTORY_ITEMS };